exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divider {\n  height: 1px;\n  border-bottom: 1px solid gray;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n.divider span {\n  background-color: white;\n  font-weight: bold;\n  font-style: italic;\n  padding: 0.5rem;\n}", ""]);

// exports
